import { useRef, useState } from 'react';
import { useInterval } from '../hooks/useInterval';
import { useGetParams } from '../hooks/useGetParams';
import { handleSocketMessage } from './handlers';

export const useSocket = ({ refs, setters, optionalParams }) => {
  const { domain, wsMaxRetries, wsRetriesDelay, wsReconnectDelay, wsPort } =
    useGetParams();

  const wsRef = useRef(null);
  const retryCountRef = useRef(0);
  const [isRegularFetch, setIsRegularFetch] = useState(false);
  const [needUpdateSocket, setNeedUpdateSocket] = useState(false);

  const startSocket = () => {
    if (wsRef.current && wsRef.current.readyState === 1) {
      return;
    }
    let webSocket;

    switch (window?.location?.protocol) {
      case 'http:':
        webSocket = new WebSocket(`ws://212.8.247.80:${wsPort}/`);
        break;
      case 'https:':
        webSocket = new WebSocket('wss://synhro.iactive.pro/wss/');
        break;
      default:
        throw new Error('Протокол не http: и не https:');
    }

    webSocket.onopen = function () {
      setNeedUpdateSocket(false);
      setIsRegularFetch(false);
      retryCountRef.current = 0;
    };

    webSocket.onclose = function () {
      if (retryCountRef.current >= wsMaxRetries) {
        setIsRegularFetch(true);
        setNeedUpdateSocket(true);
        return;
      }
      retryCountRef.current += 1;
      setTimeout(() => startSocket(), wsRetriesDelay);
    };

    webSocket.onmessage = function (data) {
      try {
        data = JSON.parse(data.data);
      } catch (e) {
        console.log({ 'info:': e, data: data.data });
        return;
      }

      const socketToken = data['socketToken'] ?? data['soсketToken']; // буква 'c' -> 'EN' ?? 'RU'
      const isCurrentDomen = socketToken?.includes(domain);

      if (isCurrentDomen) {
        handleSocketMessage(data, refs, setters, optionalParams);
      }
    };

    wsRef.current = webSocket;
  };

  // повторная попытка установить сокет соединение через wsReconnectDelay = 3 мин.
  useInterval(startSocket, needUpdateSocket ? wsReconnectDelay * 1000 : null);

  return { webSocket: wsRef.current, startSocket, isRegularFetch };
};
